export enum Response {
  Confirm,
  Cancel,
  Close,
}
